import React, { useEffect, useRef, useState } from "react";
import { Typography, Button, CircularProgress } from "@material-ui/core";
import { billingApi } from "./api";
let sdkPromise;
const loadSDK = () => {
  if (window.MercadoPago) return Promise.resolve();
  if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script"); script.src = "https://sdk.mercadopago.com/js/v2"; script.async = true;
    script.onload = resolve; script.onerror = () => { sdkPromise = null; script.remove(); reject(new Error("Não foi possível carregar o checkout do Mercado Pago.")); }; document.head.appendChild(script);
  });
  return sdkPromise;
};
export default function CardCheckout({ order, publicKey, onPayment }) {
  const [error, setError] = useState(""), [ready, setReady] = useState(false);
  const callback = useRef(onPayment); callback.current = onPayment;
  useEffect(() => {
    let active = true, controller;
    setError(""); setReady(false);
    const mount = async () => {
      try {
        await loadSDK(); if (!active) return;
        const builder = new window.MercadoPago(publicKey, { locale: "pt-BR" }).bricks();
        controller = await builder.create("payment", "saas-card-checkout", {
          initialization: { amount: order.priceCents / 100 },
          customization: { paymentMethods: { creditCard: "all", maxInstallments: 1, minInstallments: 1 } },
          callbacks: {
            onReady: () => { if (active) setReady(true); },
            onError: () => { if (active) setError("Confira os dados do cartão ou gere uma nova cobrança."); },
            onSubmit: async ({ formData }) => {
              try { const { data } = await billingApi.post(`/saas/orders/${order.id}/pay`, { formData, deviceId: window.MP_DEVICE_SESSION_ID }); if (active) callback.current(data); }
              catch (err) { if (active) setError(err.response?.data?.error || "Não foi possível concluir o pagamento."); throw err; }
            }
          }
        });
        if (!active) controller.unmount();
      } catch (err) { if (active) setError(err.message); }
    };
    mount(); return () => { active = false; if (controller) controller.unmount(); };
  }, [order.id, publicKey]);
  return <div>{!ready && !error && <CircularProgress aria-label="Carregando checkout do cartão" />}{error && <Typography color="error" role="alert">{error}</Typography>}<div id="saas-card-checkout" /></div>;
}
